<template>
    <label :for="name" :class="['large-file', {'hasFile': files.length > 0 },
    {'files-wrapper': files.length > 0}]">
        <div class="w-full flex flex-row flex-wrap box-content">
            <div v-for="(file, index) in files" :key="index">
                <div class="imagem">
                    <figure class="effect">
                        <div v-if="file.id" class="image" data-cy="imagem-id">
                            <img :src="file.imagem" alt="noticia-imagem"/>
                        </div>
                        <div v-else class="image" data-cy="imagem-sem-id">
                            <img :src="file" alt="noticia-imagem"/>
                        </div>
                        <figcaption>
                            <button
                                type="button"
                                @click.prevent="removerImagem(index, file)"
                            >
                                Remover
                            </button>
                        </figcaption>
                    </figure>
                </div>
            </div>
        </div>
        <div v-if="files.length === 0" class="icon-wrapper">
            <span v-if="title" class="icon-title">{{ title }}</span>
            <svg-icon icon="publish" class="file-image-icon"></svg-icon>
        </div>

        <input
            type="file"
            :id="name"
            class="input-file"
            :name="name"
            @change="convertImage($event)"
            :accept="accept"
        />
    </label>
</template>

<script>
export default {
    name: 'input-file',
    props: ['title', 'name', 'value', 'accept', 'icon', 'url'],
    data() {
        return {
            filename: '',
            file: '',
            type: '',
            files: []
        };
    },
    created() {
        this.parseNewVal();
        this.files = this.value;
    },
    watch: {
        value() {
            this.files = this.value;
            this.parseNewVal();
        },
    },
    methods: {
        /**
         * Processa valor novo para garantir que seja base64
         */
        async parseNewVal() {
            if (this.files.length > 0) {
                this.files.map( async (file) => {
                    try {
                        // window.atob(file.imagem);
                    } catch (e) {
                        this.file = await this.toBase64(file.imagem);
                        let fileTypeMatch = this.file.match(/(:.*;)/g)[0];
                        this.type = fileTypeMatch.substring(1,
                            fileTypeMatch.length - 1);

                        this.emitChangeFile();
                    }
                });
            } else {
                try {
                    // window.atob(this.value);
                } catch (e) {
                    this.file = await this.toBase64(this.value);
                    let fileTypeMatch = this.file.match(/(:.*;)/g)[0];
                    this.type = fileTypeMatch.substring(1,
                        fileTypeMatch.length - 1);

                    this.emitChangeFile();
                }
            }
        },
        /**
         * Transforma a url de um arquivo em base64
         */
        async toBase64(filURL) {
            return new Promise(async (resolve, reject) => {
                let file = await fetch(filURL).then(r => r.blob());
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        /**
         * Realiza a conversão da imagem correspondente para data64
         * @param event
         */
        convertImage(event) {
            this.type = event.target.files[0].type;
            this.filename = event.target.files[0].name;
            let fileReader = new FileReader();
            fileReader.readAsDataURL(event.target.files[0]);
            fileReader.onload = (event) => {
                this.file = event.target.result;
                console.log('1',this.file)
                this.files.push(this.file)
                this.emitChangeFile();
            };
        },
        async emitChangeFile() {
           this.files =  await this.files.map(file => {
                if(file.id) {
                   return file.imagem
                }else {
                    return file
                }
            });
            console.log('2', this.files)
            this.$emit(
                'changeFile',
                {
                    filename: this.filename,
                    files: this.files,
                    key_file: this.name,
                },
            );
        },
        removerImagem(index, file) {
            if(file.id) {
                this.axios.delete(`/${this.url}/${file.id}`)
                .then(response => {})
            }
            this.files.splice(index, 1)
        }
    },

};
</script>

<style lang="scss" scoped>
.large-file {
    @apply flex flex-col justify-center items-center border-light-gray border-2
    rounded-lg py-2 px-3 leading-tight bg-white;
    height: 175px;

    .icon-wrapper {
        @apply flex flex-col justify-center items-center;
    }

    span {
        @apply text-base-gray font-normal;
    }

    svg.icon {
        @apply mt-6 text-base-gray;
        width: 6rem;
        height: 6rem;
    }

    &:hover {
        @apply bg-light-gray cursor-pointer;
        span, svg.icon {
            @apply text-white;
        }
    }

    .input-file {
        @apply outline-none pointer-events-none select-none hidden;
    }
}

.files-wrapper {
    @apply flex flex-row flex-wrap;
    box-sizing: content-box;
    height: auto;
    img {
        height: 170px;
    }
    figure {
        @apply w-full relative;
        .image {
            @apply bg-black m-2;
            img {
                opacity: 0.9;
                -webkit-transition: opacity 0.35s;
                transition: opacity 0.35s;
            }
        }
        figcaption {
            @apply flex flex-col items-center justify-center absolute top-0 bottom-0 right-0 left-0 opacity-0 text-white;

            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            button {
                @apply text-sm uppercase p-4 rounded-md;
                border: 1px solid white;
            }
        }
        &:focus figcaption,
        &:hover figcaption {
            @apply opacity-100;
        }
        &:focus .image img,
        &:hover .image img {
            @apply opacity-25;
        }
    }
}

img {
    height: 170px;
}

.hasFile {
    @apply border-primary;
}

.file-image-icon {
    margin-top: 0 !important;
}

.icon-title {
    margin-bottom: 8px !important;
}
</style>
